
/* global google, markers */

/**
 * Google Map
 * ======================================
 * https://developers.google.com/maps/documentation/javascript/tutorial
 */

const WIDGET = '.js-map'
const MOBILE = window.outerWidth < 768
const ZOOM = MOBILE ? 14 : 15

class Map {
	constructor() {
		const element = document.querySelector(WIDGET)

		if (!element) {
			return false
		}

		const pos_lat = parseFloat(element.getAttribute('data-lat'))
		const pos_lng = parseFloat(element.getAttribute('data-lng'))

    const markers = [
      {"title": "iPhoneSOS", "lat": parseFloat(element.getAttribute('data-lat')), "lng": parseFloat(element.getAttribute('data-lng'))},
    ]

    if(element.getAttribute('data-widget')){
      var mapOptions = {
        zoom: ZOOM,
        center: { lat: pos_lat, lng: pos_lng },
        disableDefaultUI: true,
        zoomControl: false,
        scrollwheel: false
      }
    } else {
      var mapOptions = {
        zoom: ZOOM,
        center: { lat: pos_lat, lng: pos_lng },
        disableDefaultUI: true,
        zoomControl: true,
        zoomControlOptions: {
          position: google.maps.ControlPosition.LEFT_CENTER,
        },
        scrollwheel: false
      }
    }

		const map = new google.maps.Map(element, mapOptions)

		/**
		 * Styled map
		 */
		const styledMapType = new google.maps.StyledMapType(this.getStyles())

		map.mapTypes.set('customMapStyle', styledMapType)
		map.setMapTypeId('customMapStyle')

    const circleMarker = {
      path: google.maps.SymbolPath.CIRCLE,
      scale: 10,
      fillColor: "#F00",
      fillOpacity: 1,
      strokeWeight: 0
    }

		if (markers) {
			markers.forEach(item => {
				const marker = new google.maps.Marker({
					icon: circleMarker,
					optimized: false,
					title: item.title,
					position: { lat: item.lat, lng: item.lng }
				})
				marker.setMap(map)
			})
		}
	}

	getStyles = () => {
		return [
			{
				featureType: 'administrative',
				elementType: 'geometry',
				stylers: [
					{
						visibility: 'off'
					}
				]
			},
        {
          featureType: 'administrative.neighborhood',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'administrative.land_parcel',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'administrative.locality',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
			{
				featureType: 'poi',
				stylers: [
					{
						visibility: 'on'
					}
				]
			},
			{
				featureType: 'road',
				elementType: 'labels',
				stylers: [
					{
						visibility: 'off'
					}
				]
			},
			{
				featureType: 'road',
				elementType: 'labels.icon',
				stylers: [
					{
						visibility: 'off'
					}
				]
			},
			{
				featureType: 'road.arterial',
				stylers: [
					{
						visibility: 'off'
					}
				]
			},
			{
				featureType: 'road.highway',
				elementType: 'labels',
				stylers: [
					{
						visibility: 'on'
					}
				]
			},
			{
				featureType: 'road.local',
				stylers: [
					{
						visibility: 'on'
					}
				]
			},
			{
				featureType: 'transit',
				stylers: [
					{
						visibility: 'on'
					}
				]
			},
			{
				featureType: 'water',
				elementType: 'labels.text',
				stylers: [
					{
						visibility: 'off'
					}
				]
			}
		]
	}
}

new Map()

